<div class="p-3">
  <div class="flex flex-column gap-3">
    <div class="p-3 mb-2 surface-100 border-round border-left-3 border-orange-500">
      <div class="flex align-items-center gap-2 mb-2">
        <i class="pi pi-exclamation-triangle text-orange-500"></i>
        <span class="font-semibold text-orange-700">Important Notice</span>
      </div>
      <p class="text-sm text-700 m-0">
        Static services are manually managed products that do not originate from NetSapiens. 
        Please ensure you select the correct site and product before adding.
      </p>
    </div>

    <div class="field">
      <label for="static-site" class="font-semibold block mb-2">Site *</label>
      <p-dropdown
        id="static-site"
        [options]="sites"
        optionLabel="site"
        optionValue="site"
        [filter]="true"
        filterBy="site"
        placeholder="Select a site"
        [(ngModel)]="location"
        class="w-full"
      ></p-dropdown>
    </div>

    <div class="field">
      <label for="static-product-code" class="font-semibold block mb-2">Product Code *</label>
      <p-dropdown
        id="static-product-code"
        [options]="availableStaticServiceCodes"
        [(ngModel)]="selectedStaticServiceCode"
        optionLabel="code"
        [showClear]="true"
        placeholder="Select a static service code"
        class="w-full"
        (onChange)="onStaticServiceCodeSelected($event.value)"
        [filter]="true"
        filterBy="code,description"
      >
        <ng-template let-code pTemplate="item">
          <div class="flex flex-column">
            <span class="font-medium">{{ code.code }}</span>
            <small class="text-600">{{ code.description }}</small>
            <small class="text-500" *ngIf="code.category">{{ code.category }}</small>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <div class="field">
      <label for="static-description" class="font-semibold block mb-2">Description</label>
      <input
        id="static-description"
        type="text"
        pInputText
        [(ngModel)]="description"
        class="w-full"
        placeholder="Description (auto-filled from selected code)"
        [readonly]="!!selectedStaticServiceCode"
      />
    </div>

    <div class="formgrid grid">
      <div class="field col-6">
        <label for="static-quantity" class="font-semibold">Quantity *</label>
        <input
          id="static-quantity"
          type="number"
          pInputText
          [(ngModel)]="quantity"
          [min]="1"
          class="w-full"
          placeholder="Enter quantity"
        />
      </div>
      <div class="field col-6">
        <label for="static-rate" class="font-semibold">Rate (Optional)</label>
        <input
          id="static-rate"
          type="number"
          pInputText
          [ngModel]="rate"
          (ngModelChange)="onRateChange($event)"
          [min]="0"
          step="0.01"
          class="w-full"
          [placeholder]="catalogRate ? 'Rate: ' + formatCurrency(catalogRate) : 'Enter rate'"
        />
        <small class="text-600" *ngIf="catalogRate !== undefined && catalogRate !== null">
          Catalog rate: {{ formatCurrency(catalogRate) }} (you can edit)
        </small>
      </div>
    </div>

    <div class="field">
      <label for="static-effective-date" class="font-semibold block mb-2">Effective Date (Optional)</label>
      <p-calendar
        id="static-effective-date"
        [(ngModel)]="effectiveDate"
        [showIcon]="true"
        dateFormat="yy-mm-dd"
        [showButtonBar]="true"
        [showTime]="false"
        placeholder="Select effective date (defaults to today)"
        [appendTo]="'body'"
        [baseZIndex]="10000"
        [panelStyleClass]="'static-service-calendar-panel'"
        styleClass="w-full"
      ></p-calendar>
      <small class="text-600">
        Date when this change will take effect in the billing cycle. If not set,
        it will default to today.
      </small>
    </div>
  </div>
</div>

<div class="p-dialog-footer">
  <button
    pButton
    type="button"
    label="Cancel"
    icon="pi pi-times"
    class="p-button-text"
    (click)="cancel()"
  ></button>
  <button
    pButton
    type="button"
    label="Add"
    icon="pi pi-plus"
    class="p-button-success"
    [disabled]="!location || !selectedStaticServiceCode || !quantity || quantity < 1"
    (click)="save()"
  ></button>
</div>
